import { render, staticRenderFns } from "./StarsRating.vue?vue&type=template&id=69eea8a4&scoped=true&"
import script from "./StarsRating.vue?vue&type=script&lang=js&"
export * from "./StarsRating.vue?vue&type=script&lang=js&"
import style0 from "./StarsRating.vue?vue&type=style&index=0&id=69eea8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eea8a4",
  null
  
)

export default component.exports